module.exports = __webpack_public_path__ + "img/play_icon.b1870d21.svg";